// extracted by mini-css-extract-plugin
module.exports =  {"label":"Label-module__label___Q8zsa","label_inline":"Label-module__label_inline____WtKR"};